import { useToastedMutation } from '../../../../ReactQuery';
import { post } from '../../../../redux/api';
import { hardRedirectTo } from '../../../../utils';
import type { GitHubAppInstallUrlResponse } from '../../../../../shared/types/routes/vcs/githubApp';
import type { VcsApp } from '../../../../../shared/vcs/githubApp/apps';

const startGitHubAppInstall = async (app: VcsApp) => {
  const response = await post<Record<string, never>, GitHubAppInstallUrlResponse>(
    `/api/vcs/github-apps/${app}/install-url`,
    {},
  );
  return response.data as GitHubAppInstallUrlResponse;
};

/**
 * Asks vcs-service for a GitHub App install URL and redirects the user to it.
 * The install completes when GitHub redirects back to
 * `/api/vcs/github-apps/install-callback`.
 */
export function useStartGitHubAppInstall() {
  return useToastedMutation({
    mutationFn: startGitHubAppInstall,
    onSuccess: ({ installUrl }) => {
      hardRedirectTo(installUrl);
    },
    errorToastMessage: 'Failed to start GitHub App installation',
  });
}
